import { useState } from 'react';
import { cn, PermissionUtils } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api';
import { UserItemHead } from './userItemHead';
import { UserContacts } from './userContacts';
import { UserLongInfo } from './userLongInfo';
import { ShortInfo } from './shortInfo';

export interface UserProps {
  className?: string;
  user: UserWithPaymentInfo;
}

export const User = (props: UserProps) => {
  const [showUserLongInfo, setShowUserLongInfo] = useState<boolean>(false);

  return (
    <div
      className={cn(
        'relative min-w-[300px] rounded-lg bg-white transition-shadow duration-200 dark:bg-soft-black',
        PermissionUtils.viewUserPage() && 'hover:shadow-lg dark:hover:shadow-lg-dark',
        props.className,
      )}
    >
      <div>
        <UserItemHead show={showUserLongInfo} onToggle={() => setShowUserLongInfo((prev) => !prev)} user={props.user} />
        {showUserLongInfo ? (
          <div className='no-scrollbar z-50 max-h-[300px] w-full overflow-auto rounded-b-lg bg-white dark:bg-soft-black'>
            <UserContacts user={props.user} />
            <UserLongInfo user={props.user} />
          </div>
        ) : (
          <ShortInfo type={props.user.userType} locked={props.user.locked} cards={props.user.cards.length} accounts={props.user.accounts.length} />
        )}
      </div>
    </div>
  );
};
